import type { LiabilityFormLayout } from "../types";

export const liabilitySubtypeLayout = (): LiabilityFormLayout => {
  return {
    render: 'subtype'
  }
}
